import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';

export const StatCard = ({ icon: Icon, label, value, color, testid }) => (
  <Card data-testid={testid}>
    <CardContent className="p-4 flex items-center gap-3">
      <div className={`p-3 rounded-lg ${color}`}>
        <Icon size={20} className="text-white" />
      </div>
      <div>
        <p className="text-xs text-gray-500">{label}</p>
        <p className="text-2xl font-bold">{value}</p>
      </div>
    </CardContent>
  </Card>
);
